import { cn } from "utils/cn";
import SegmentedControlNode from "./SegmentedControlNode";
import { useId } from "react";

export type SegmentedControlOption = {
  value: any,
  label?: string;
};

export type SegmentedControlReturnValue = {
  selectedOptionIndex: number;
  selectedValue: any;
};

export type ThresholdIndicator = {
  indicatorIndex: number;
  indicatorLabel?: string;
  indicatorContainerStyles?: string;
  indicatorBarStyles?: string;
};

interface SegmentedControlProps {
  selectedOptionIndex: number;
  fieldSetLabel?: string;
  options: SegmentedControlOption[];
  onChange: (valueData: SegmentedControlReturnValue) => void;
  className?: string;

  // Optional Props
  // must use the hex for the colors due to limitations 
  thresholdIndicators?: ThresholdIndicator[];
  nodeClassName?: string;
  nodeOuterDivClassName?: string;
}

const SegmentedControl = ({
  selectedOptionIndex, onChange, options, fieldSetLabel, className,
  thresholdIndicators = [],
  // optional props
  nodeClassName, nodeOuterDivClassName,
}: SegmentedControlProps) => {
  const id = useId();

  return (
    <fieldset className={className}>
      <legend className="sr-only">{fieldSetLabel || "Select Quantity"}</legend>
      <div className="flex items-center w-full">
        {
          options.map((option, index) => {
            const isChecked = index === selectedOptionIndex;
            const isNodeActive = index <= selectedOptionIndex;
            const isBarActive = index < selectedOptionIndex;

            const thresholdIndicatorData = thresholdIndicators
              ? thresholdIndicators.find((thresholdIndicator) => (thresholdIndicator.indicatorIndex === index))
              : undefined;

            if (index === options.length - 1) {
              return (
                <SegmentedControlNode
                  key={`${id}-${index}`}
                  checked={isChecked}
                  isActive={isNodeActive}
                  value={option.value}
                  className={nodeClassName}
                  outerDivClassName={nodeOuterDivClassName}
                  thresholdIndicator={thresholdIndicatorData}
                  onChange={() => {
                    onChange({ selectedOptionIndex: index, selectedValue: option.value })
                  }}
                />
              )
            }

            return (
              <>
                <SegmentedControlNode
                  key={`${id}-${index}`}
                  checked={isChecked}
                  isActive={isNodeActive}
                  outerDivClassName={cn(
                    "mr-[5px]",
                    nodeOuterDivClassName,
                  )}
                  value={option.value}
                  className={nodeClassName}
                  thresholdIndicator={thresholdIndicatorData}
                  onChange={() => {
                    onChange({ selectedOptionIndex: index, selectedValue: option.value })
                  }}
                />
                <div
                  className={cn(
                    `grow border border-primary-segmented-control-green h-[2px] rounded-xl`,
                    isBarActive ? `bg-primary-segmented-control-green` : `bg-white`
                  )}
                />
              </>
            )
          })
        }
      </div>
    </fieldset>
  )
};

export default SegmentedControl;